import validate from "/azp/agent/_work/11/s/frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45login_45global from "/azp/agent/_work/11/s/frontend/middleware/01-login.global.js";
import _02_45auth_45global from "/azp/agent/_work/11/s/frontend/middleware/02-auth.global.js";
import _03_45external_45forms_45global from "/azp/agent/_work/11/s/frontend/middleware/03-external-forms.global.js";
import _04_45i18n_45global from "/azp/agent/_work/11/s/frontend/middleware/04-i18n.global.js";
import _05_45routes_45global from "/azp/agent/_work/11/s/frontend/middleware/05-routes.global.js";
import _06_45maintenance_45global from "/azp/agent/_work/11/s/frontend/middleware/06-maintenance.global.js";
import _07_45dynamic_45theme_45global from "/azp/agent/_work/11/s/frontend/middleware/07-dynamic-theme.global.js";
import manifest_45route_45rule from "/azp/agent/_work/11/s/frontend/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  _01_45login_45global,
  _02_45auth_45global,
  _03_45external_45forms_45global,
  _04_45i18n_45global,
  _05_45routes_45global,
  _06_45maintenance_45global,
  _07_45dynamic_45theme_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}